import rolesService from '@/services/rolesService'

const state = {
  roles: [],
  loadingRol: false,
  loadingRoles: true,
  paginationRoles: {
    page: 1,
    itemsPerPage: 50
  },
  totalRoles: 0,
  selectedRol: {}
}

const mutations = {
  'SET_TOTAL_ROLES' (state, totalRoles) {
    state.totalRoles = totalRoles
  },
  'SET_ROLES' (state, roles) {
    state.roles = roles
  },
  'SET_LOADING_ROL' (state, status) {
    state.loadingRol = status
  },
  'SET_LOADING_ROLES' (state, status) {
    state.loadingRoles = status
  },
  'SET_PAGINATION_ROLES' (state, pagination) {
    state.paginationRoles = pagination
  },
  'SET_SELECTED_ROL' (state, rol) {
    state.selectedRol = rol
  }
}

const actions = {
  createRol (vuexContext, { name, code }) {
    return new Promise((resolve, reject) => {
      rolesService.createRol(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        { name, code })
        .then(() => {
          vuexContext.dispatch('getRoles')
          resolve(true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // getUser (vuexContext, uuid) {
  //   return new Promise((resolve, reject) => {
  //     vuexContext.commit('SET_LOADING_USER', true)
  //     rolesService.getUser(vuexContext.getters.token, vuexContext.getters.companyUuid, vuexContext.getters.appUuid, uuid)
  //     .then(response => {
  //       if (response.users.count > 0) {
  //         vuexContext.commit('SET_SELECTED_USER', response.users.rows[0])
  //       } else {
  //         vuexContext.commit('SET_SELECTED_USER', {})
  //       }
  //       vuexContext.commit('SET_LOADING_USER', false)
  //     })
  //   })
  // },
  getRoles (vuexContext) {
    vuexContext.commit('SET_LOADING_ROLES', true)
    rolesService.getRoles(vuexContext.getters.token, vuexContext.getters.companyUuid, vuexContext.getters.appUuid, vuexContext.state.paginationRoles)
      .then(response => {
        vuexContext.commit('SET_TOTAL_ROLES', response.roles.count)
        vuexContext.commit('SET_ROLES', response.roles.rows)
        vuexContext.commit('SET_LOADING_ROLES', false)
      })
      .catch((error) => {
        console.log(error)
        vuexContext.commit('SET_ROLES', [])
        vuexContext.commit('SET_LOADING_ROLES', false)
      })
  },
  updateRol (vuexContext, { roleId, name, code }) {
    return new Promise((resolve, reject) => {
      rolesService.updateRol(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        roleId,
        { name, code })
        .then(() => {
          vuexContext.dispatch('getRoles')
          resolve(true)
        })
    })
  }
}

const getters = {
  totalRoles (state) {
    return state.totalRoles
  },
  rolCode (state) {
    return state.selectedRol.code
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
